import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'mbnm-reset-project-dialog',
    templateUrl: './pending-changes-dialog.component.html',
    styleUrls: ['./pending-changes-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PendingChangesDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
